<template>
  <div class="acceptance">
    <b-form>
      <h2>Offer Acceptance</h2>
      <p>Please tick the box below to confirm you accept Trailfinders offer of employment.</p>

      <b-form-group>
          <div class="checkbox checkbox-custom">
              <input id="accepted"
                     name="accepted"
                     type="checkbox"
                     :value="true"
                     v-model="accepted"
              >
              <label for="accepted">Accept Offer</label>
          </div>
      </b-form-group>

    </b-form>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { updateForm } from '../../helpers/index'
export default {
  computed: {
    ...mapGetters({
      getRecruit: 'authStore/getRecruit',
      getOnboardingComplete: 'authStore/getOnboardingComplete'
    }),
    ...mapState({form: state => state.authStore.recruit.onboarding.onboardingForms.acceptanceLetter})
  },
  data () {
    return {
      formName: 'acceptanceLetter',
      file: '',
      accepted: false
    }
  },
  mounted () {
    this.$v.$touch()
        setTimeout(() => {
          this.accepted = this.form.accepted;
      }, 1000)
  },
  updated () {
    const validationData = {
      section: 'acceptance',
      status: this.accepted
    }
    this.updateForm('accepted', this.accepted);
    this.updateOnboardingCompleteAction(validationData)
  },
  methods: {
    ...mapActions({
      updateOnboardingFormAction: 'authStore/updateOnboardingFormAction',
      currentOnboardingFormAction: 'authStore/currentOnboardingFormAction',
      updateOnboardingCompleteAction: 'authStore/updateOnboardingCompleteAction',
    }),
    updateForm
  },
  validations: {
    form: {
    }
  }
}
</script>

<style scoped>
.file-input {
  display: flex;
  align-items: center;
  height: 100%;
}
</style>
